import { Heading, Icon, IconButton, Text, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { useNavigation } from '@react-navigation/native';
import { useCallback } from 'react';
import { Pressable } from 'react-native';

import { SignedInNavigationScreenNavigationProp } from '../../../../routes/types';

export const Header = () => {
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const navigation = useNavigation<SignedInNavigationScreenNavigationProp>();

  const handleGoBack = useCallback(() => {
    navigation.navigate('ProductsManagement');
  }, [navigation]);

  if (isMobile) {
    return (
      <VStack pt={Spacing['inset.md']} px={Spacing['inline.xxxs']} space={Spacing['inset.nano']}>
        <HStack alignItems="center" justifyContent="space-between">
          <HStack alignItems="center" space={Spacing['inline.xxs']}>
            <Pressable onPress={handleGoBack}>
              <Icon name="ArrowLeft" color={Color['brand.primary.principal']} size="xxs" />
            </Pressable>
            <Text
              testId="qa"
              variant="semibold"
              lineHeight="distant"
              fontSize={Typography['fontsize.lg']}>
              Controle de produtos
            </Text>
          </HStack>
        </HStack>
      </VStack>
    );
  }

  return (
    <HStack alignItems="center" justifyContent="space-between" py={Spacing['inset.md']}>
      <HStack alignItems="center" space={Spacing['inline.xxxs']}>
        <IconButton
          icon="ArrowLeft"
          testId="return-button"
          shadow={3}
          variant="link"
          onPress={handleGoBack}
          iconColor={Color['brand.tertiary.principal']}
          iconSize="xs"
        />
        <Heading testId="qa" size="h2">
          Controle de produtos
        </Heading>
      </HStack>
    </HStack>
  );
};
